  import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './styles.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Service from './pages/Service';
import Feature from './pages/Feature';
import Advisor from './pages/Advisor';
import Review from './pages/Review';
import Blog from './pages/Blog';
import Single from './pages/Single';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

const appName = 'Goal Path HR Solution';
const titleMap = {
  '/': appName,
  '/about': `About | ${appName}`,
  '/service': `Service | ${appName}`,
  '/feature': `Feature | ${appName}`,
  '/advisor': `Advisor | ${appName}`,
  '/review': `Review | ${appName}`,
  '/blog': `Blog | ${appName}`,
  '/single': `Single | ${appName}`,
  '/contact': `Contact | ${appName}`,
  '*': `Not Found | ${appName}`,
};

function App() {
  const location = useLocation();

  useEffect(() => {
    document.title = titleMap[location.pathname] || appName;
  }, [location.pathname]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/feature" element={<Feature />} />
        <Route path="/advisor" element={<Advisor />} />
        <Route path="/review" element={<Review />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/single" element={<Single />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default App;
